/** Ключи meta принадлежат модулю Меркурий, а не ядру. */
export const META_MERCURY_LOGIN = 'mercuryApiLogin'
export const META_MERCURY_PASSWORD = 'mercuryApiPassword'
